import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SitesDataGrid } from "src/components/views/erp/common/sites/SitesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/sites")({
	staticData: { title: i18n.t("sites"), legacyViewKey: "sitesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SitesDataGrid />;
}
